module.exports = __webpack_public_path__ + "static/media/galia.257d6cc2.png";